import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { EncryptedStorageService } from 'app/core/service/EncryptedStorage.service';
import { LoginCoordinatorService } from 'app/core/service/login-coordinator.service';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {

    constructor(private authService: AuthService, private router: Router, private encryptedStorageService: EncryptedStorageService,
        private loginCoordinator: LoginCoordinatorService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this.checkAuthentication(state.url);
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this.checkAuthentication(state.url);
    }

    private checkAuthentication(url: string): Observable<boolean | UrlTree> {
        return this.authService.check().pipe(
            switchMap(authenticated => {
                // Accept either app-managed bearer or raw accessToken from root-config
                const bearer = this.encryptedStorageService.getItem('Authorization');
                const accessToken = localStorage.getItem('accessToken');
                const hasToken = !!(bearer || (accessToken && accessToken !== 'null' && accessToken !== 'undefined'));
                if (!authenticated && !hasToken) {
                    const redirectURL = url === '/sign-out' ? '' : `redirectURL=${url}`;
                    const urlTree = this.router.parseUrl(`/sign-in?${redirectURL}`);
                    return of(urlTree);
                }
                // If token exists but app not yet authenticated, trigger sign-in flow with token
                if (!authenticated && hasToken) {
                    const payload = { oneCoherentIsTrue: true, message: 'SSO Login', data: { accessToken: accessToken, refreshToken: '' } };
                    this.loginCoordinator.triggerLoginWithToken(payload);
                }
                return of(true);
            })
        );
    }
}
